import IAutoCompleteItem from './IAutoCompleteItem';

interface AutocompleteSettings {
    /** Inputfield for extend with autocomplete */
    owner: HTMLInputElement;
    /** Array of AutoCompleteItem used for List */
    items: Array<IAutoCompleteItem>;
    /** set another input field for set selected value (AutoCompleteItem.ID) */
    valueField?: HTMLInputElement;
    /**
     * Override label in itemlist
     * @param label string contains default label
     * @param item AutoCompleteItem current item
     */
    setLabel?(label: string, item: IAutoCompleteItem): string;
    /**
     * Callback after select item
     * @param item selected item
     */
    onSelect?(item: IAutoCompleteItem): void;
    autoOpen?: boolean;
    fontello?: {
        prefix?: string;
        opener?: string;
        closer?: string;
    };
}

class HTMLAcElement extends HTMLDivElement {
    public item: IAutoCompleteItem;
    constructor() {
        super();
    }
}

export default class Autocomplete {
    protected itemList: HTMLAcElement = null;
    protected settings: AutocompleteSettings = null;
    protected selectedItem: HTMLAcElement = null;
    protected tabIndex = 999;

    /**
     *
     * @param settings Settings for Autocomplete
     */
    constructor(settings: AutocompleteSettings) {
        const _this = this;
        _this.settings = settings;

        _this.itemList = <HTMLAcElement>document.createElement('div');
        _this.itemList.id = 'myInputautocomplete-list';
        _this.itemList.classList.add('autocomplete-items');
        _this.settings.owner.insertAdjacentElement('afterend', _this.itemList);

        let arrow = document.createElement('i');
        if (!_this.settings.fontello) {
            arrow.classList.add('sp');
            arrow.classList.add('sp-down-open-big');
        } else {
            arrow.classList.add(_this.settings.fontello.prefix);
            arrow.classList.add(_this.settings.fontello.opener);
        }
        _this.settings.owner.insertAdjacentElement('afterend', arrow);
        arrow.addEventListener('click', (ev) => _this.toggleOpen(true,ev));
        _this.settings.owner.addEventListener('input', () => _this.eventInput());
        _this.settings.owner.addEventListener('keydown', (ev) => _this.eventKeyboard(ev));
        _this.settings.owner.classList.add('ac-owner');
        if (_this.settings.owner.value !== '') {
            _this.settings.owner.focus();
            _this.settings.owner.selectionStart = _this.settings.owner.selectionEnd =
                _this.settings.owner.value.length;
            _this.eventInput();
            let items = <NodeListOf<HTMLAcElement>>_this.itemList.querySelectorAll('.ac-item');
            console.log(items);
            if (items.length > 0) {
                _this.selectedItem = items[0];
                _this.eventKeyboard(new KeyboardEvent('Enter', { key: 'Enter' }));
            }
        }
        if (_this.settings.autoOpen) {
            _this.settings.owner.addEventListener('click', (ev) => _this.autoOpen(ev));
            _this.settings.owner.addEventListener('touch', (ev) => _this.autoOpen(ev));
        }
        document.addEventListener('click', (ev: PointerEvent) => {
            let close = true;
            ev.path.forEach((el) => {
                if (el.classList && el.classList.contains('ac-owner')) {
                    close = false;
                }
            });
            if (close) {
                _this.toggleOpen(false, ev);
            }
        });
        if (_this.settings.items.length) {
            _this.selectItem(0);
            _this.settings.items.forEach((element) => {
                if (element.selected) {
                    _this.selectItem(element.index);
                }
            });
        }
    }

    protected autoOpen(ev: Event) {
        const _this = this;
        _this.toggleOpen(true,ev);
        _this.settings.owner.select();
        _this.settings.owner.setSelectionRange(0, _this.settings.owner.value.length);
    }

    public selectItem(index: number = 0) {
        const _this = this;
        _this.settings.valueField.value = _this.settings.items[index].data;
        _this.settings.owner.value = _this.settings.items[index].label;
    }

    private toggleOpen(open: boolean = true, ev: Event) {
        const _this = this;
        ev.stopImmediatePropagation();
        if (_this.itemList.innerHTML !== '') {
            _this.clearList();
        } else {

            if (open) {
                _this.eventInput(true);
            }
        }
        return false;
    }

    private eventInput(force: boolean = false) {
        const _this = this;
        let rx = new RegExp(_this.settings.owner.value, 'i');
        let result = _this.settings.items;
        if (!force) {
            result = _this.settings.items.filter((obj) => {
                return obj.label.match(rx);
            });
        }
        _this.clearList();
        result.forEach((item, index) => {
            _this.addItem(item, rx, index);
        });
    }

    private eventKeyboard(ev: KeyboardEvent) {
        if (['ArrowDown', 'ArrowUp', 'Enter'].indexOf(ev.key) > -1) {
            const _this = this;
            let items = <NodeListOf<HTMLAcElement>>_this.itemList.querySelectorAll('.ac-item');
            ev.preventDefault();
            switch (ev.key) {
                case 'ArrowDown':
                    if (!_this.selectedItem) {
                        _this.selectedItem = items[0];
                    } else {
                        _this.selectedItem.classList.remove('autocomplete-active');
                        _this.selectedItem = <HTMLAcElement>_this.selectedItem.nextElementSibling;
                    }
                    break;
                case 'ArrowUp':
                    if (!_this.selectedItem) {
                        _this.selectedItem = items[0];
                    } else {
                        _this.selectedItem.classList.remove('autocomplete-active');
                        _this.selectedItem = <HTMLAcElement>(
                            _this.selectedItem.previousElementSibling
                        );
                    }
                    break;
                case 'Enter':
                    _this.itemSelect(
                        _this.selectedItem.querySelector('input'),
                        _this.selectedItem.item
                    );
                    ev.stopPropagation();
                    break;
            }
            if (_this.selectedItem) {
                _this.selectedItem.classList.add('autocomplete-active');
                _this.selectedItem.focus();
                _this.settings.owner.focus();
            }
            return false;
        }
    }

    /**
     * Add item to autocomplte-list
     * @param item Item to add
     * @param rx RegEx
     * @param index index for tabindex
     */
    private addItem(item: IAutoCompleteItem, rx: RegExp, index: number) {
        let _this = this;
        let listItem: HTMLAcElement = <HTMLAcElement>document.createElement('div');
        let itemInput = document.createElement('input');
        itemInput.type = 'hidden';
        itemInput.value = item.id;
        let markedLabel = item.label;
        markedLabel = markedLabel.replace(
            rx,
            '<strong>' + _this.settings.owner.value + '</strong>'
        );
        if (_this.settings.setLabel) {
            markedLabel = _this.settings.setLabel(markedLabel, item);
        }
        listItem.item = item;
        listItem.tabIndex = 999 + index;
        listItem.classList.add('ac-item');
        listItem.innerHTML = markedLabel;
        listItem.insertAdjacentElement('beforeend', itemInput);
        listItem.addEventListener('click', () => _this.itemSelect(itemInput, item));
        listItem.addEventListener('touch', () => _this.itemSelect(itemInput, item));
        _this.itemList.insertAdjacentElement('beforeend', listItem);
        _this.selectedItem = null;
    }

    /**
     *
     * @param listItem
     * @param itemInput
     * @param item
     */
    private itemSelect(itemInput: HTMLInputElement, item: IAutoCompleteItem) {
        const _this = this;
        if (_this.settings.valueField) {
            _this.settings.valueField.value = itemInput.value;
            _this.clearList();
            _this.settings.owner.value = item.label;
            _this.settings.owner.focus();
        }
        if (_this.settings.onSelect) {
            _this.settings.onSelect(item);
        }
    }

    /**
     * remove all items
     */
    private clearList() {
        this.itemList.innerHTML = '';
    }
}
